// hooks/useLatestPickData.ts
import { useState, useEffect } from "react";
import { getDocs, collection, doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase/FirebaseConfig";

export function useLatestPickData() {
  const [picks, setPicks] = useState<any[] | null>(null);
  const [latestWeek, setLatestWeek] = useState<any | null>(null);
  const [latestQuarter, setLatestQuarter] = useState<any | null>(null);
  const [latestISODate, setLatestISODate] = useState<string>("");

  const convertToISODate = (weekDate: string): string => {
    if (!weekDate) return "";
    const cleaned = weekDate.replace(/[()]/g, "");
    const [mm, dd, yy] = cleaned.split("/");
    const date = new Date(`20${yy}-${mm}-${dd}`);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "pickData"));
        const quarters: any[] = querySnapshot.docs.map((d) => ({
          ...d.data(),
          docId: d.id,
        }));
        const sortedQuarter = quarters.sort(
          (a, b) => b.quarterId - a.quarterId
        )[0];
        if (!sortedQuarter) return;

        const docRef = doc(db, "pickData", sortedQuarter.docId);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) return;

        const fullData = docSnap.data();
        const latestWeek = fullData.weeks.sort(
          (a: any, b: any) => b.weekId - a.weekId
        )[0];

        setPicks(latestWeek.picks);
        setLatestWeek(latestWeek);
        setLatestQuarter(sortedQuarter);
        setLatestISODate(convertToISODate(latestWeek.weekDate));
      } catch (err) {
        console.error("Error fetching pick data:", err);
      }
    };

    fetchData();
  }, []);

  return { latestQuarter, latestWeek, latestISODate, picks };
}
